import { notificationsService } from "../services/notifications.service";
import type {
  AssignmentNotice,
  AssignmentNoticePage,
} from "../types/casePathologistAssignment";

const NOTICE_PAGE_LIMIT = 50;
const MAX_SEEN_NOTICE_IDS = 250;

export async function loadAssignmentNoticePoll(
  checkpointCursor?: string
): Promise<AssignmentNoticePage> {
  return loadAssignmentNoticePage(checkpointCursor, []);
}

export function selectUnseenNotices(
  notices: AssignmentNotice[],
  seenIds: Set<string>,
  seenOrder: string[]
): AssignmentNotice[] {
  const unseen = notices.filter(({ id }) => !seenIds.has(id));
  unseen.forEach(({ id }) => {
    seenIds.add(id);
    seenOrder.push(id);
  });
  trimSeenNoticeIds(seenIds, seenOrder);
  return unseen;
}

async function loadAssignmentNoticePage(
  cursor: string | undefined,
  notices: AssignmentNotice[]
): Promise<AssignmentNoticePage> {
  const page = await notificationsService.getPathologistAssignmentNotices({
    cursor,
    limit: NOTICE_PAGE_LIMIT,
  });
  const accumulatedNotices = [...notices, ...page.data];
  const nextCursor = nextPageCursor(page, cursor);
  return page.hasMore
    ? loadAssignmentNoticePage(nextCursor, accumulatedNotices)
    : { ...page, data: accumulatedNotices };
}

function nextPageCursor(
  page: AssignmentNoticePage,
  previousCursor?: string
): string {
  if (page.nextCursor === previousCursor) {
    throw new Error("Assignment notice pagination did not advance.");
  }
  return page.nextCursor;
}

function trimSeenNoticeIds(seenIds: Set<string>, seenOrder: string[]): void {
  const removeCount = Math.max(0, seenOrder.length - MAX_SEEN_NOTICE_IDS);
  const removedIds = seenOrder.splice(0, removeCount);
  removedIds.forEach((id) => seenIds.delete(id));
}
